export default function TermsOfService({ onClose }) {
  const ov = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,.72)',
    zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 20, fontFamily: "'Outfit',sans-serif",
  };
  const box = {
    background: '#161b22', border: '1px solid #21262d', borderRadius: 16,
    width: '100%', maxWidth: 680, maxHeight: '88vh',
    display: 'flex', flexDirection: 'column',
  };
  const hd = {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '18px 24px', borderBottom: '1px solid #21262d', flexShrink: 0,
  };
  const body = {
    overflowY: 'auto', padding: '24px 28px',
    color: '#c9d1d9', fontSize: 13, lineHeight: 1.8,
  };
  const h2 = { fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 800, color: '#fff', marginBottom: 6 };
  const h3 = { fontSize: 14, fontWeight: 700, color: '#f5f0e8', margin: '20px 0 6px' };
  const p  = { marginBottom: 12, color: '#8b949e' };

  return (
    <div style={ov} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={box}>
        <div style={hd}>
          <div style={h2}>Terms of Service</div>
          <button
            style={{ background: 'none', border: '1px solid #2d333b', borderRadius: 8, color: '#8b949e', cursor: 'pointer', padding: '4px 10px', fontSize: 18, lineHeight: 1 }}
            onClick={onClose}>×</button>
        </div>

        <div style={body}>
          <p style={{ ...p, color: '#484f58', fontSize: 12 }}>Last updated: January 1, 2026 · Effective: January 1, 2026</p>

          <p style={p}>
            Welcome to RentLord. By accessing or using our platform, you agree to be bound by these Terms of Service.
            Please read them carefully before creating an account.
          </p>

          <div style={h3}>1. Acceptance of Terms</div>
          <p style={p}>
            By creating an account, accessing, or using RentLord's services, you acknowledge that you have read,
            understood, and agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree,
            do not use our platform.
          </p>

          <div style={h3}>2. Description of Service</div>
          <p style={p}>
            RentLord provides a cloud-based property management platform for residential landlords and tenants in the
            Dallas-Fort Worth metropolitan area and beyond. Features include rent collection, tenant management, lease
            tracking, maintenance request management, document storage, and related tools.
          </p>

          <div style={h3}>3. Eligibility</div>
          <p style={p}>
            You must be at least 18 years old to use RentLord. By using our service, you represent that you are of
            legal age and have the legal capacity to enter into binding agreements. If you are using the service on
            behalf of a business or entity, you represent that you are authorized to bind that entity.
          </p>

          <div style={h3}>4. Account Registration</div>
          <p style={p}>
            You agree to provide accurate, current, and complete information when creating your account. You are
            responsible for maintaining the confidentiality of your login credentials and for all activity that
            occurs under your account. Notify us immediately at support@rentlordapp.com of any unauthorized use.
          </p>

          <div style={h3}>5. Subscription and Billing</div>
          <p style={p}>
            RentLord offers paid subscription plans (Starter, Pro, Portfolio). All plans include a 14-day free trial.
            After the trial period, your selected plan will be billed monthly. Subscriptions auto-renew unless
            cancelled. You may cancel at any time; cancellation takes effect at the end of the current billing period.
            No refunds are provided for partial billing periods.
          </p>

          <div style={h3}>6. Acceptable Use</div>
          <p style={p}>
            You agree not to: (a) use the platform for any unlawful purpose; (b) violate any applicable fair housing,
            landlord-tenant, or anti-discrimination laws; (c) transmit harmful, offensive, or fraudulent content;
            (d) attempt to gain unauthorized access to our systems; (e) resell or redistribute access to the platform.
          </p>

          <div style={h3}>7. Fair Housing Compliance</div>
          <p style={p}>
            RentLord does not facilitate discrimination. You agree to comply with all applicable federal, state, and
            local fair housing laws, including the Fair Housing Act, in all your activities as a landlord. RentLord
            reserves the right to suspend accounts found to be in violation.
          </p>

          <div style={h3}>8. Data and Privacy</div>
          <p style={p}>
            Your use of RentLord is also governed by our Privacy Policy. You retain ownership of data you input into
            the platform. By using the service, you grant RentLord a limited license to use your data solely to
            provide and improve the service. We do not sell your personal data to third parties.
          </p>

          <div style={h3}>9. Intellectual Property</div>
          <p style={p}>
            All content, software, and materials comprising the RentLord platform are the property of RentLord LLC
            or its licensors, protected by copyright, trademark, and other intellectual property laws. You are
            granted a limited, non-exclusive, non-transferable license to use the platform for its intended purpose.
          </p>

          <div style={h3}>10. Limitation of Liability</div>
          <p style={p}>
            To the maximum extent permitted by applicable law, RentLord shall not be liable for any indirect,
            incidental, special, consequential, or punitive damages, including loss of profits or data, arising
            from your use of the platform. Our total liability to you shall not exceed the amount you paid us in
            the 12 months preceding the claim.
          </p>

          <div style={h3}>11. Disclaimer of Warranties</div>
          <p style={p}>
            The platform is provided "as is" and "as available" without warranties of any kind. RentLord does not
            warrant that the service will be uninterrupted, error-free, or completely secure. We are not a law
            firm and nothing on the platform constitutes legal advice.
          </p>

          <div style={h3}>12. Termination</div>
          <p style={p}>
            Either party may terminate this agreement at any time. RentLord may suspend or terminate your account
            for violation of these terms, non-payment, or any reason with 30 days notice. Upon termination, you
            may export your data within 30 days.
          </p>

          <div style={h3}>13. Governing Law</div>
          <p style={p}>
            These Terms are governed by the laws of the State of Texas, without regard to conflict of law principles.
            Any disputes shall be resolved in the state or federal courts located in Dallas County, Texas.
          </p>

          <div style={h3}>14. Changes to Terms</div>
          <p style={p}>
            We may update these Terms from time to time. We will notify you of material changes via email or
            in-app notification. Continued use of the platform after changes constitutes acceptance of the new terms.
          </p>

          <div style={h3}>15. Contact</div>
          <p style={p}>
            Questions about these Terms? Contact us at: <strong style={{ color: '#4ade80' }}>legal@rentlordapp.com</strong>
            {' '}or by mail at RentLord LLC, Dallas, TX 75201.
          </p>
        </div>

        <div style={{ padding: '14px 24px', borderTop: '1px solid #21262d', flexShrink: 0, display: 'flex', justifyContent: 'flex-end' }}>
          <button
            style={{ background: 'linear-gradient(135deg,#16a34a,#4ade80)', color: '#0a1a0a', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: "'Outfit',sans-serif" }}
            onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}
